import React from 'react'

import { Dialog, DialogContent, DialogTitle, FormControl, Grid, InputLabel } from '@mui/material'
import { CustomDetailInput } from 'style'

import type { MstSupplier, MstCenterSupplier } from 'api-client'

interface SupplierDetailProps {
  supplier: MstSupplier | undefined
  centerSupplier?: MstCenterSupplier | undefined
  open?: boolean;
  onClose?: () => void
}

function SupplierDetail({ supplier, centerSupplier, open = false, onClose }: SupplierDetailProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle variant='largeBold'>仕入先詳細</DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>
          <Grid component="div" size={{ xs: 4 }}>
            <FormControl fullWidth>
              <InputLabel>仕入先ID</InputLabel>
              <CustomDetailInput size="small" value={supplier?.orgSupplierId ?? ""} />
            </FormControl>
          </Grid>

          <Grid component="div" size={{ xs: 8 }}>
            <FormControl fullWidth>
              <InputLabel>仕入先名</InputLabel>
              <CustomDetailInput size="small" doubleWidth value={supplier?.supplierName ?? ""} />
            </FormControl>
          </Grid>

          <Grid component="div" size={{ xs: 4 }}>
            <FormControl fullWidth>
              <InputLabel>1回あたり最低発注数</InputLabel>
              <CustomDetailInput size="small" value={centerSupplier?.trMinOrderQuantityOnce ?? supplier?.minOrderQuantityOnce ?? ""} />
            </FormControl>
          </Grid>

          <Grid component="div" size={{ xs: 4 }}>
            <FormControl fullWidth>
              <InputLabel>発注リードタイム</InputLabel>
              <CustomDetailInput size="small" value={centerSupplier?.trOrderLeadtime} />
            </FormControl>
          </Grid>

          <Grid component="div" size={{ xs: 4 }}>
            <FormControl fullWidth>
              <InputLabel>締め時間</InputLabel>
              <CustomDetailInput size="small" value={centerSupplier?.trOrderLimitTime} />
            </FormControl>
          </Grid>

          <Grid component="div" size={{ xs: 4 }}>
            <FormControl fullWidth>
              <InputLabel>平準化基準</InputLabel>
              <CustomDetailInput size="small" value={centerSupplier?.optimizeType} />
            </FormControl>
          </Grid>

          <Grid component="div" size={{ xs: 4 }}>
            <FormControl fullWidth>
              <InputLabel>平準化期間</InputLabel>
              <CustomDetailInput size="small" value={centerSupplier?.optimizeRange} />
            </FormControl>
          </Grid>

          <Grid component="div" size={{ xs: 4 }}>
            <FormControl fullWidth>
              <InputLabel>入荷停止</InputLabel>
              <CustomDetailInput size="small" value={centerSupplier?.stopArrival} />
            </FormControl>
          </Grid>

          <Grid component="div" size={{ xs: 4 }}>
            <FormControl fullWidth>
              <InputLabel>統一企業ID</InputLabel>
              <CustomDetailInput size="small" value={supplier?.supplierCompanyId ?? ""} />
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>

    </Dialog>
  )
}

export default SupplierDetail